import React from "react";
import { TitledContent } from "./TitledContent";
import { defineMessage, FormattedMessage } from "react-intl";
import StringFilter from "./StringFilter";
import { useLoaderData } from "react-router-dom";
import { Stack } from "@mui/material";
import { ListResult } from "../utils/crud";
import user from "../descriptors/user";
import List from "./List";
import ResourceFormButton from "./ResourceFormButton";

const UsersPage: React.FC = () => {
    const data = useLoaderData() as ListResult;
    const descriptor = user;
    const resourceName = "user";

    return (
        <TitledContent
            title={<FormattedMessage id="user.list" defaultMessage="$users.list" />}
            action={
                <ResourceFormButton
                    resourceName={resourceName}
                    action="create"
                    dialogTitle={defineMessage({
                        id: "user.create",
                        defaultMessage: "$users.create",
                    })}
                />
            }
        >
            <Stack spacing={2}>
                <StringFilter
                    filterField="free"
                    placeholder={defineMessage({
                        id: "user.filter_placeholder",
                        defaultMessage: "Search for login name, alias, or full name..",
                    })}
                />
                <List
                    data={data.rows}
                    maxPage={Math.ceil(data.count / descriptor.listDefaults.limit)}
                    header={descriptor.orders.list}
                    uri={new URL(window.location.href)}
                    renderers={descriptor.renderers?.list}
                    fieldNameKeyFactory={(fieldName: string) => `${resourceName}.${fieldName}`}
                />
            </Stack>
        </TitledContent>
    );
};

export default UsersPage;
